export default __webpack_public_path__ + "static/media/art1.03acfdd0.jpg";